<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
    <!-- 登录 -->
    <loginDialog v-if="loginModelShow" @closeLoginDialog="closeLoginDialog"/>
    <!-- 登出 -->
    <loginOut v-model="loginOutShow" @closeLoginOutDialog="closeLoginOutDialog" @reloginHandle="reloginHandle"/>
     <!-- 存储空间不足 -->
     <insufficientSpace v-model="spaceShow" @closeDialog="closeSpace" @goManage="goManage"/>
  </div>
</template>

<script name="App" setup>
import { onMounted,provide,ref, watch } from "vue";
import { useRouter, useRoute } from 'vue-router'
import loginOut from '@/layout/components/dialogs/loginOut.vue';
import loginDialog from '@/components/loginModal/index.vue'; //登录弹窗
import insufficientSpace from '@/layout/components/dialogs/insufficientSpace.vue'
import { usePageStatusStore } from "@/store/modules/pageStatus";
const pageStatusStore = usePageStatusStore();
const route = useRoute();
const router = useRouter();
onMounted(()=>{
  setTimeout(()=>{
    pageStatusStore.changeLoadingStatus()
  },2000)
  
})
import { useUserStore } from '@/store'
import { storeToRefs } from 'pinia';

const { access, requestCode } = storeToRefs(useUserStore());

const loginModelShow = ref(false); //登录显示

const spaceShow = ref(false); //空间不足

const loginOutShow = ref(false);

const closeSpace = () => {
  spaceShow.value = false;
}

const goManage = () => {
  spaceShow.value = false;
  router.push({path: '/myCreation/index',query: {isManage: true}})
}
watch(()=>requestCode.value, (newValue)=>{
  console.log('requestCode',access.value)
  if(newValue == 217 || newValue == 205){
    if(!access.value){
      // if(route.path == '/edit'){
      //   router.push({path: '/'})
      // }
      loginModelShow.value = true;
    }else{
      loginOutShow.value = true;
    }
    
  }
})

// 打开登录
const loginShowHandle = () =>{
  loginModelShow.value = true;
}

// 关闭登录
const closeLoginDialog = () => {
  loginModelShow.value = false;
}

// 关闭登出弹窗
const closeLoginOutDialog = () =>{
  loginOutShow.value = false;
}

const reloginHandle = () =>{
  loginOutShow.value = false;
  loginModelShow.value = true;
}

// 检查是否登录了
const checkOrDoLogin = () => {
  if (access.value && access.value.accessToken) {
    return true;
  } else {
    console.log('登录')
    loginShowHandle();
    return false;
  }
}

provide('checkOrDoLogin', checkOrDoLogin);
provide('closeLoginDialog',closeLoginDialog);
provide('loginShowHandle',loginShowHandle);
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.command_seleted{
    background: #E5E6EB;
}
</style>
